import { useState, useEffect } from 'react';

interface Props {
  endsAt: string;
  color: string;
}

const PromoCountdown = ({ endsAt, color }: Props) => {
  const calc = () => {
    const diff = Math.max(0, new Date(endsAt).getTime() - Date.now());
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor((diff % 86400000) / 3600000),
      m: Math.floor((diff % 3600000) / 60000),
      s: Math.floor((diff % 60000) / 1000),
    };
  };

  const [time, setTime] = useState(calc);

  useEffect(() => {
    const t = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(t);
  }, [endsAt]);

  const pad = (n: number) => String(n).padStart(2, '0');

  const units = [
    { val: time.d, label: 'дн' },
    { val: time.h, label: 'ч' },
    { val: time.m, label: 'мин' },
    { val: time.s, label: 'сек' },
  ];

  return (
    <div className="flex items-center gap-2">
      <i className="ri-time-line text-sm" style={{ color }} />
      <span className="font-mono text-xs text-white/40 mr-1">До конца:</span>
      <div className="flex items-center gap-1">
        {units.map((u, i) => (
          <div key={u.label} className="flex items-center gap-1">
            <div
              className="flex flex-col items-center px-2 py-1 rounded-lg"
              style={{ background: `${color}15`, border: `1px solid ${color}30` }}
            >
              <span className="font-orbitron font-black text-sm leading-none" style={{ color, textShadow: `0 0 8px ${color}` }}>
                {pad(u.val)}
              </span>
              <span className="font-mono text-[9px] text-white/30 mt-0.5">{u.label}</span>
            </div>
            {i < units.length - 1 && (
              <span className="font-orbitron font-bold text-sm" style={{ color, opacity: 0.5 }}>:</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PromoCountdown;
